<mat-expansion-panel class="container"  [expanded]="true" [hideToggle]="true">
  
  <ng-container #componentPlaceholder> </ng-container>
</mat-expansion-panel>
